// File: layouts/MainLayout.tsx

import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import GlobalTopBar from "@/components/GlobalTopBar";
import { useSidebar } from "@/context/SidebarContext";
import { cn } from "@/lib/utils";

export default function MainLayout() {
  const { collapsed, isInitialized } = useSidebar();

  // Show a minimal layout while sidebar initializes to prevent layout shift
  if (!isInitialized) {
    return (
      <div className="min-h-screen bg-background text-foreground">
        {/* Full-width top bar */}
        <div className="sticky top-0 z-30 w-full">
          <GlobalTopBar />
        </div>
        
        {/* Placeholder sidebar space to prevent layout shift */}
        <div className="fixed top-[60px] left-0 h-[calc(100vh-60px)] w-16 bg-card border-r border-border z-40" />
        
        {/* Main content area with placeholder spacing */}
        <div className="min-h-screen ml-16 pt-[60px] transition-all duration-200 ease-in-out">
          {/* Loading content */}
          <main className="bg-background p-6">
            <div className="mx-auto max-w-7xl">
              <div className="flex items-center justify-center h-64">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 dark:border-blue-400"></div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* GlobalTopBar - Full width, always at top */}
      <div className="sticky top-0 z-30 w-full">
        <GlobalTopBar />
      </div>

      {/* Sidebar - Fixed positioning below GlobalTopBar */}
      <div className="fixed  left-0 h-[calc(100vh-60px)] z-40">
        <Sidebar />
      </div>

      {/* Main content area - properly spaced from sidebar, no shift on hover */}
      <div 
        className={cn(
          "min-h-screen transition-all duration-200 ease-in-out",
          // Fixed margin-left that doesn't change on hover
          "ml-10" // Always 64px margin, sidear expands over content
        )}
        // Account for GlobalTopBar height
      >
        {/* Page Content - standardized container with proper padding */}
        <main className="bg-background p-0">
          <div className="mx-auto max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}